import { useQuery } from '@tanstack/react-query';

import { Api } from '@/shared/api';
import { useCurrentProject } from '@/shared/projects/project-path';

export function useGetPublishers() {
  const project = useCurrentProject();
  return useQuery({
    queryKey: [project, 'publishers'],
    initialData: {
      publishers: [],
    },
    queryFn: () => Api.publishers.getPublishers(project),
  });
}
